import {
  ChannelConfiguration,
  CreateChannelConfigurationRequest,
  GetChannelConfigurationsResponse,
} from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient, parseRequestOptionsToUrlParams } from '../utils';
import { RequestOptions } from './requestOptions';

export const getChannelConfigurations = (options?: RequestOptions<ChannelConfiguration>) =>
  HttpClient.get<GetChannelConfigurationsResponse>(API_FACTORY.v1('admin/channels'), parseRequestOptionsToUrlParams(options));

export const createChannelConfiguration = (request: CreateChannelConfigurationRequest): Promise<ChannelConfiguration> =>
  HttpClient.post<ChannelConfiguration>(API_FACTORY.v1('admin/channels'), request);

export const updateChannelConfiguration = (request: ChannelConfiguration): Promise<ChannelConfiguration> =>
  HttpClient.put<ChannelConfiguration>(API_FACTORY.v1(`admin/channels/${request.id}`), request);

export const deleteChannelConfiguration = (id: string): Promise<void> =>
  HttpClient.delete<void>(API_FACTORY.v1(`admin/channels/${id}`));
